// src/components/MealDetailsPage/MealDetailsPage.jsx
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import data from "../../data/meals.json"; // JSON dosyasını içe aktarın
import "../../dist.css/MealDetailsPage.css"; // Stil dosyasını unutmayın
import Salad from "../../img/salad.gif";
import Hat from "../../img/hat.gif";
import Video from "../../img/video.gif";
import { motion } from "framer-motion";
import ReactPlayer from "react-player";
import { useLikedMeals } from "../../context/LikedMealsContext"; // Context'ten hook'u import et
import CommentForm from "../CommentForm/CommentForm";
import { toast, ToastContainer } from "react-toastify"; // react-toastify'yi dahil ettik
import "react-toastify/dist/ReactToastify.css"; // Stil dosyasını dahil ettik

const MealDetailsPage = () => {
  const { idMeal } = useParams();
  const { addMealToLiked } = useLikedMeals(); // Context'ten addMealToLiked fonksiyonunu al
  const [likedMeals, setLikedMeals] = useState([]); // Beğenilen yemekleri saklar
  // Meal verisini filtrele
  const meal = data.meals.find((meal) => meal.idMeal === idMeal);

  const handleLike = () => {
    if (likedMeals.includes(meal.idMeal)) {
      // Eğer yemek zaten beğenilmişse
      toast.error("Bu yemeği zaten beğendiniz!"); // Hata bildirimi
    } else {
      // Yeni bir yemek beğeniliyor
      setLikedMeals((prev) => [...prev, meal.idMeal]); // meal.idMeal kullanarak beğenilen yemekleri ekliyoruz
      toast.success("Yemeğiniz beğenildi!"); // Başarı bildirimi
    }

    addMealToLiked(meal); // Beğenilen yemeği context'e ekliyoruz
  };

  const handleSpeak = () => {
    if (!window.speechSynthesis) {
      alert("Tarayıcınız metin seslendirme özelliğini desteklemiyor.");
      return;
    }

    const instructions = meal.strInstructions.split(". ");
    const utterance = new SpeechSynthesisUtterance(instructions.join(". "));
    utterance.lang = "tr-TR"; // Türkçe dil kodu
    window.speechSynthesis.speak(utterance);
  };

  if (!meal) {
    return <div>Yemek bulunamadı.</div>;
  }

  return (
    <div className="meal__details__page">
      <div className="meal__details">
        <motion.div
          className="left__container"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5, type: "spring" }}
        >
          <img src={meal.strMealThumb} alt="Meal" />
          <div className="meal__name">
            <h2>{meal.strMeal}</h2>
            <p className="meal__area">
              <i className="bx bx-map"></i>
              {meal.strArea}
            </p>
            <p>Kategori: {meal.strCategory}</p>
          </div>
        </motion.div>

        <div className="body__container">
          <div className="ingredients__container">
            <motion.h2
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                duration: 1,
                delay: 1,
                ease: "easeOut",
                type: "spring",
                stiffness: 200,
              }}
            >
              <img src={Salad} alt="Salad" />
              Malzemeler
            </motion.h2>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                duration: 1,
                delay: 1.2,
                ease: "easeOut",
                type: "spring",
                stiffness: 200,
              }}
            >
              <ul className="ingredients">
                {Array.from({ length: 20 }, (_, i) => i + 1).map(
                  (i) =>
                    meal[`strIngredient${i}`] && (
                      <li key={i} className="ingredient">
                        {/* <img
                          src={`${meal[`strIngredientIMG${i}`]
                          }`}
                          alt="ingredient"
                        /> */}
                        <div className="ingredient__info">
                          <h2>{meal[`strIngredient${i}`]}</h2>
                          <p>{meal[`strMeasure${i}`]}</p>
                        </div>
                      </li>
                    )
                )}
              </ul>
              <motion.button
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{
                  duration: 1,
                  delay: 1,
                  ease: "easeOut",
                  type: "spring",
                  stiffness: 200,
                }}
                className="find__btn btn"
                onClick={handleLike}
              >
                Beğendim
              </motion.button>
              <ToastContainer
                position="top-right" // Bildirim sağ üstte görünsün
                autoClose={3000} // 3 saniye sonra kaybolur
                hideProgressBar={true} // İlerleme çubuğunu gizle
                newestOnTop={true} // En yeni bildirim üstte
                closeButton={false} // Kapatma butonunu gizle
                rtl={false} // Arapça okuma yönü
              />
            </motion.div>
          </div>

          <div className="instruction__container">
            <motion.h2
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                duration: 1,
                delay: 1,
                ease: "easeOut",
                type: "spring",
                stiffness: 200,
              }}
            >
              <img src={Hat} alt="Hat" />
              Talimatlar
            </motion.h2>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                duration: 1,
                delay: 1.2,
                ease: "easeOut",
                type: "spring",
                stiffness: 200,
              }}
            >
              <div className="instruction">
                {meal.strInstructions.split(". ").map((instruction, index) => (
                  <p key={index}>
                    <i className="bx bx-cube-alt"></i>
                    {instruction}
                  </p>
                ))}
              </div>
              <button className="find__btn btn" onClick={handleSpeak}>
                Talimatları Seslendir
              </button>
            </motion.div>
          </div>
        </div>

        {meal.strYoutube && (
          <motion.div
            className="video__container"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{
              duration: 1,
              delay: 3,
              ease: "easeOut",
              type: "spring",
              stiffness: 200,
            }}
          >
            <h2>
              <img src={Video} alt="Video" /> Yapılışı!
            </h2>
            <div className="video">
              <ReactPlayer
                width="100%"
                className="video"
                height="550px"
                url={meal.strYoutube}
              />
            </div>
          </motion.div>
        )}
        <CommentForm />
      </div>
    </div>
  );
};

export default MealDetailsPage;
